export const required = value => (value ? undefined : 'Required');

export const maxLength = max => value =>
	(value && value.length > max ? `Must be ${max} characters or less` : undefined);

export const maxLength500 = maxLength(500);

export const rangeLength = range => value =>
	(value && value.length !== range ? `Must be ${range} characters` : undefined);

export const rangeLength10 = rangeLength(10);

// export const number = value => (value && isNaN(Number(value)) ? "Must be a number" : undefined);

export const minValue = min => value =>
	(value && value < min ? `Must be at least ${min}` : undefined);
export const minValue18 = minValue(18);

export const email = value =>
	(value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
		'Invalid email address' : undefined);

export const tooOld = value =>
	(value && value > 65 ? 'You might be too old for this' : undefined);

export const aol = value =>
	(value && /.+@aol\.com/.test(value) ?
		'Really? You still use AOL for your email?' : undefined);

// password validation

export const validUrl = value => (
	value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) ?
	undefined : 'Not Valid URL'
);

export const validate = (values) => {
	const errors = {};
	if (!values.new_password) {
		// errors.new_password = "Required";
	}
	if (!values.confirm_password) {
		// errors.confirm_password = "Required";
	} else if (values.confirm_password !== values.new_password) {
		errors.confirm_password = 'Password mismatched';
	}
	return errors;
};

export const FieldLevelValidation = (validate, value) => {
	let error = [];
	if (validate && validate.length > 0) {
		if (validate.includes('required')) {
			error.push(required(value));
		}
		if (validate.includes('maxLength500')) {
			error.push(maxLength500(value));
		}
		if (validate.includes('validUrl')) {
			error.push(validUrl(value));
		}
		if (validate.includes('rangeLength10')) {
			error.push(rangeLength10(value));
		}
		if (validate.includes('email')) {
			error.push(email(value));
		}
	}
	return error;
};



// WEBPACK FOOTER //
// ./common/Forms/Validation/FieldLevelValidation.js